/**
 * Client fuer die Mapping-Job-Endpunkte (#57/#93): Jobs des Multi-Agent-
 * OMOP-Mapping, ihre Kandidaten und die getroffenen Entscheidungen.
 */
import { API_BASE_URL, API_ENDPOINTS, buildApiUrl } from '../config/api';
import { apiRequest, normalizeListResponse } from './httpClient';

function url(endpoint, params = {}) {
  return `${API_BASE_URL}${buildApiUrl(endpoint, params)}`;
}

export async function listMappingJobs() {
  const data = await apiRequest(url(API_ENDPOINTS.MAPPING_JOBS.LIST));
  return normalizeListResponse(data, { source: 'listMappingJobs' });
}

export async function createMappingJob(payload) {
  return apiRequest(url(API_ENDPOINTS.MAPPING_JOBS.LIST), {
    method: 'POST',
    body: payload,
  });
}

export async function getMappingJob(jobId) {
  return apiRequest(url(API_ENDPOINTS.MAPPING_JOBS.DETAIL, { id: jobId }));
}

export async function getMappingJobCandidates(jobId) {
  const data = await apiRequest(url(API_ENDPOINTS.MAPPING_JOBS.CANDIDATES, { id: jobId }));
  return normalizeListResponse(data, { source: 'getMappingJobCandidates' });
}

export async function submitMappingJobDecision(jobId, decision) {
  return apiRequest(url(API_ENDPOINTS.MAPPING_JOBS.DECISIONS, { id: jobId }), {
    method: 'POST',
    body: decision,
  });
}
